/** Períodos do filtro da listagem de NF-e de saída (História 08, listagem de notas fiscais). */
export enum PeriodoNotaFiscalSaidaEnum {
  Ultimos30Dias = 1,
  DoDia = 2,
  DoMes = 3,
  DoIntervalo = 4,
  SemFiltro = 5,
}
